import { z } from "zod";

// Coordinate
export const CoordinateSchema = z.object({
  latitude: z.string(),
  longitude: z.string(),
});
export type Coordinate = z.infer<typeof CoordinateSchema>;

// Single address
export const AddressDetailsSchema = z.object({
  addressId: z.string(),
  streetName: z.string(),
  houseNumber: z.number(),
  letter: z.string().nullable(),
  postalCode: z.string(),
  city: z.string(),
  coordinate: CoordinateSchema,
});
export type AddressDetails = z.infer<typeof AddressDetailsSchema>;

// List of addresses returned by the server
export const AddressDetailsListSchema = z.array(AddressDetailsSchema);
export type AddressDetailsList = z.infer<typeof AddressDetailsListSchema>;
